import Guid from "common/values/guid/guid";
import Notification from "notifications/entities/notification/notification";
import moment from "moment";
import NotificationTopic from "notifications/values/notification-topic/notification-topic";
import NotificationMessage from "notifications/values/notification-message/notification-message";
import NotificationRecipient from "notifications/values/notification-recipient/notification-recipient";

export class NotificationRecipientAPIResponse {
    userId?: string;
    seenAt?: string | null;

    constructor(data?: Partial<NotificationRecipientAPIResponse>) {
        Object.assign(this, data);
    }

    deserialize(): NotificationRecipient {
        if (this.userId === undefined) throw new Error("Recipient userId not returned.");
        return new NotificationRecipient(
            new Guid(this.userId),
            this.seenAt ? moment(this.seenAt) : null
        );
    }
}

export default class NotificationAPIResponse {
    id?: string;
    recipients?: Partial<NotificationRecipientAPIResponse>[];
    senderId?: string;
    message?: string;
    topicCategory?: string;
    topicId?: string | null;
    actionRequired?: string;
    isCanceled?: boolean;
    createdDate?: string;
    senderName?: string;
    recipientName?: string;

    constructor(data?: Partial<NotificationAPIResponse>) {
        Object.assign(this, data);
    }

    deserialize(): Notification {
        if (this.id === undefined) throw new Error("Message id not returned.");
        if (this.recipients === undefined) throw new Error("Message recipients not returned.");
        if (this.recipients.length === 0) throw new Error("Message recipients not returned.");
        if (this.message === undefined) throw new Error("Message message not returned.");
        if (this.topicCategory === undefined) throw new Error("Message topicCategory not returned.");
        if (this.actionRequired === undefined) throw new Error("Message actionRequired not returned.");
        if (this.isCanceled === undefined) throw new Error("Message isCanceled not returned.");
        if (this.createdDate === undefined) throw new Error("Message createdDate not returned.");


        const topicIdGuid = this.topicId ? new Guid(this.topicId) : null;
        return new Notification(
            new Guid(this.id),
            this.recipients.map((recipient) => new NotificationRecipientAPIResponse(recipient).deserialize()),
            this.senderId ? new Guid(this.senderId) : undefined,
            new NotificationMessage(this.message),
            this.topicCategory ? new NotificationTopic(
                this.topicCategory,
                topicIdGuid
            ) : null,
            this.actionRequired,
            moment(this.createdDate),
            this.isCanceled,
            this.senderName,
            this.recipientName
        );
    }
}
